 export const getUrlParams = (param, location) => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(param);
}